import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";
// import { transformRequest } from "../../utils/API/requestMiddleware";

// create bug Task API

const bugTaskAPI = createApi({
    reducerPath: "bugtaskAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getBugTaskByTaskId: builder.query({
            query: (TaskId) => ({
                url:`/TaskBug/GetAllTaskBugListByTaskId?TaskId=${TaskId}`,
                
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addTaskBug:builder.mutation({
            query:(data)=>({
                url:`/TaskBug/AddTaskBug`,
                method:'POST',
                body:transformRequest(data)
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse,
        })
        
    })
})

export const{
    useLazyGetBugTaskByTaskIdQuery,
    useAddTaskBugMutation
} = bugTaskAPI;

export default bugTaskAPI;